/* eslint-disable */
import "../../components/component-questionnaire/B4FDate/react-datepicker.css";

import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  getPart,
  updateFundPart,
} from "../../utils/store/actions/funds.actions";
import {
  Input,
  Button,
  Card,
  CardContent,
  Chip,
  MenuItem,
  Select as SelectMultiple,
} from "@material-ui/core";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { B4FSelect } from "../../components/component-questionnaire/B4FFields/B4FSelect";
import { B4FDate } from "../../components/component-questionnaire/B4FDate/B4FDate";
import { FormControl, FormLabel } from "@chakra-ui/react";
import B4FCurrency from "../../components/component-questionnaire/B4FFields/B4FCurrency";
import { B4FNumber } from "../../components/component-questionnaire/B4FFields/B4FNumber";
import { B4FRadio } from "../../components/component-questionnaire/B4FFields/B4FRadio";
import { B4FText } from "../../components/component-questionnaire/B4FFields/B4FText";
import { getEnums } from "../../utils/store/actions/survey.action";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 800,
    },
  },
};

const styles = (theme: Theme) =>
  createStyles({
    fundCards: {
      borderRadius: "12px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    chip: {
      margin: 2,
    },
    savePart: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "-webkit-fill-available",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
    },
  });
class PartForm extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      part: {},
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  fundPersonId = this.urlParams.get("id");

  async componentDidMount() {
    this.setState({ part: this.props.Funds.part });
  }

  handleSave = (e: any) => {
    this.props.updateFundPart(this.state.part, this.fundPersonId).then(() => {
      this.props.getPart(this.fundPersonId, this.state.part.id);
    });
  };

  render() {
    const { classes, t, Surveys } = this.props;
    return (
      <div>
        <div style={{ margin: "1%", fontWeight: "bolder" }}>
          {t("INFORMATIONS")[0].toUpperCase() +
            t("INFORMATIONS").slice(1).toLowerCase()}
        </div>
        <Card className={classes.card}>
          <CardContent className={classes.fundCards}>
            <B4FSelect
              label="MAIN_CURRENCY"
              value={this.state.part.currency}
              onBlur={console.log}
              id="currency"
              key="currency"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    currency: e.value,
                  },
                });
              }}
              options={Surveys?.enums["currency-codes"]}
              isRequired={false}
              visible={true}
            />
            <B4FDate
              id="creationDate"
              key="creationDate"
              label="CREATION_DATE"
              value={`${this.state.part.creationDate}`}
              visible={true}
              language="FR"
              isRequired={false}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    creationDate: e.target.value,
                  },
                });
              }}
              onUpdate={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    creationDate: e.target.value,
                  },
                });
              }}
              isDisabled={false}
              onBlur={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    creationDate: e.target.value,
                  },
                });
              }}
              minDate=""
            />
            <FormControl isRequired={false}>
              <B4FCurrency
                label="MINIMUM_INVESTMENT"
                id="minimumInvestment"
                value={
                  this.state.part?.minimumInvestment
                    ? [
                        this.state.part?.minimumInvestment?.value,
                        this.state.part?.minimumInvestment?.currency,
                      ]
                    : this.state.part?.minimumInvestment || ["", ""]
                }
                onChange={(e: any) => {
                  if (e.id === "minimumInvestment.value") {
                    this.setState({
                      part: {
                        ...this.state.part,
                        minimumInvestment: {
                          ...this.state.part.minimumInvestment,
                          value: e.value,
                        },
                      },
                    });
                  }
                  if (e.id === "minimumInvestment.currency") {
                    this.setState({
                      part: {
                        ...this.state.part,
                        minimumInvestment: {
                          ...this.state.part.minimumInvestment,
                          currency: e.value,
                        },
                      },
                    });
                  }
                }}
                onUpdate={console.log}
                onBlur={console.log}
                visible={true}
                isRequired={false}
                disabled={false}
              />
            </FormControl>
            <B4FNumber
              label="MAXIMUM_INVESTMENT"
              isDisabled={false}
              id="maximumInvestment"
              value={this.state?.part?.maximumInvestment}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    maximumInvestment: e.value,
                  },
                });
              }}
              visible={true}
              isRequired={false}
            />
            <B4FRadio
              label="IS_PART_OPEN_TO_CANADIAN_INVESTOR"
              key="isPartOpenToCanadianInvestor"
              id="isPartOpenToCanadianInvestor"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    isPartOpenToCanadianInvestor: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.isPartOpenToCanadianInvestor?.toString()}
              isRequired={false}
              visible={true}
            />
            <B4FText
              label="PART_ISIN"
              value={this.state?.part?.partIsin}
              onBlur={console.log}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    partIsin: e.value,
                  },
                });
              }}
              id="partIsin"
              key="partIsin"
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
            {/* Min not acquired commission */}
            <B4FNumber
              label="MINIMUM_ENTRANCE_FEES"
              isDisabled={false}
              id="minAquiredCommision"
              value={this.state?.part?.minNotAcquiredCommission}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    minNotAcquiredCommission: Number(e),
                  },
                });
              }}
              visible={true}
              isRequired={false}
              percentage
            />
            {/* Max not acquired commission */}
            <B4FNumber
              label="MAXIMUM_ENTRANCE_FEES"
              isDisabled={false}
              id="maxAquiredCommision"
              value={this.state?.part?.maxNotAcquiredCommission}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    maxNotAcquiredCommission: Number(e),
                  },
                });
              }}
              visible={true}
              isRequired={false}
              percentage
            />

            <B4FCurrency
              label="DURATION_OF_RECOMMENDED_PLACEMENT"
              id="recommendedInvestmentPeriod"
              value={
                [
                  this.state.part?.recommendedInvestmentPeriod,
                  this.state.part?.recommendedInvestmentPeriodPeriodicity,
                ] || ["", ""]
              }
              onChange={(e: any) => {
                if (e.id === "recommendedInvestmentPeriod.value") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      recommendedInvestmentPeriod: e.value,
                    },
                  });
                }
                if (e.id === "recommendedInvestmentPeriod.currency") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      recommendedInvestmentPeriodPeriodicity: e.value,
                    },
                  });
                }
              }}
              onUpdate={console.log}
              onBlur={console.log}
              visible={true}
              isRequired={false}
              disabled={false}
            />
            <B4FRadio
              label="IS_OPEN_TO_NON_PRORESSIONAL"
              key="isOpenToNonProfessionalInvestor"
              id="isOpenToNonProfessionalInvestor"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    isOpenToNonProfessionalInvestor: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.isOpenToNonProfessionalInvestor?.toString()}
              isRequired={false}
              visible={true}
            />
            <B4FCurrency
              label="NON_ACQUIRED_COMMISSIONS"
              id="nonAcquiredCommission"
              value={
                [
                  this.state.part?.nonAcquiredCommission?.value,
                  this.state.part?.nonAcquiredCommission?.currency,
                ] || ["", ""]
              }
              onChange={(e: any) => {
                if (e.id === "nonAcquiredCommission.value") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      nonAcquiredCommission: {
                        ...this.state.part.nonAcquiredCommission,
                        value: e.value,
                      },
                    },
                  });
                }
                if (e.id === "nonAcquiredCommission.currency") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      nonAcquiredCommission: {
                        ...this.state.part.nonAcquiredCommission,
                        currency: e.value,
                      },
                    },
                  });
                }
              }}
              onUpdate={console.log}
              onBlur={console.log}
              visible={true}
              isRequired={false}
              disabled={false}
            />
            <B4FRadio
              label="IS_PART_OPEN_TO_US_INVESTOR_PERSON"
              key="isPartOpenToUsInvestorPerson"
              id="isPartOpenToUsInvestorPerson"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    isPartOpenToUsInvestorPerson: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.isPartOpenToUsInvestorPerson?.toString()}
              isRequired={false}
              visible={true}
            />

            <B4FCurrency
              label="ACQUIRED_COMMISSIONS"
              id="acquiredCommission"
              value={
                [
                  this.state.part?.acquiredCommission?.value,
                  this.state.part?.acquiredCommission?.currency,
                ] || ["", ""]
              }
              onChange={(e: any) => {
                if (e.id === "acquiredCommission.value") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      acquiredCommission: {
                        ...this.state.part.acquiredCommission,
                        value: e.value,
                      },
                    },
                  });
                }
                if (e.id === "acquiredCommission.currency") {
                  this.setState({
                    part: {
                      ...this.state.part,
                      acquiredCommission: {
                        ...this.state.part.acquiredCommission,
                        currency: e.value,
                      },
                    },
                  });
                }
              }}
              onUpdate={console.log}
              onBlur={console.log}
              visible={true}
              isRequired={false}
              disabled={false}
            />
            <B4FRadio
              label="IS_PART_OPEN_TO_ELIGIBLE_COUNTERPARTY"
              key="isPartOpenToEligibleCounterParty"
              id="isPartOpenToEligibleCounterParty"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    isPartOpenToEligibleCounterParty: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.isPartOpenToEligibleCounterParty?.toString()}
              isRequired={false}
              visible={true}
            />
            <B4FRadio
              label="VISIBLE_FOR_EXTERNAL_SALES"
              key="visibleForExternalSales"
              id="visibleForExternalSales"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    visibleForExternalSales: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.visibleForExternalSales?.toString()}
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
            <B4FNumber
              label="UNIQUE_PRICE_OF_PART"
              isDisabled={false}
              key="uniquePriceOfPart"
              id="uniquePriceOfPart"
              value={this.state?.part?.uniquePriceOfPart}
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    uniquePriceOfPart: e.value,
                  },
                });
              }}
              visible={true}
              isRequired={false}
            />
            <FormControl id="propertySubscriberDeclarations">
              <FormLabel>{t("SUBSCRIPTION_CONSERVATION")}</FormLabel>
              <SelectMultiple
                labelId="demo-mutiple-chip-label"
                multiple
                autoWidth
                value={
                  this.state?.part?.subscriberDeclarationAndGuarantee || []
                }
                onChange={(e: any, value: any) => {
                  this.setState({
                    part: {
                      ...this.state.part,
                      subscriberDeclarationAndGuarantee: e.target.value,
                    },
                  });
                }}
                renderValue={(selected: any) => (
                  <div>
                    {selected.map((value: any) => {
                      const label =
                        Surveys?.enums &&
                        Surveys?.enums["subscriber-declarations-shares"]?.find(
                          (obj: any) => obj.key === value
                        )?.label;
                      return (
                        <Chip
                          style={{ maxWidth: "200px" }}
                          key={value}
                          label={label ? t("ENUMS." + label) : ""}
                          className={classes.chip}
                        />
                      );
                    })}
                  </div>
                )}
                input={<Input id="select-multiple-chip" />}
                MenuProps={MenuProps}
              >
                {Surveys?.enums &&
                  Surveys?.enums["subscriber-declarations-shares"]?.map(
                    (obj: any) => {
                      return (
                        <MenuItem
                          id="subscriber-declarations-shares"
                          key={obj.key}
                          value={obj.key}
                        >
                          {t("ENUMS." + obj?.label)}
                        </MenuItem>
                      );
                    }
                  )}
              </SelectMultiple>
            </FormControl>
            <B4FRadio
              label="IS_PART_OPEN_TO_TRANSFER_OPERATION"
              key="isPartOpenToTransferOperation"
              id="isPartOpenToTransferOperation"
              onChange={(e: any) => {
                this.setState({
                  part: {
                    ...this.state.part,
                    isPartOpenToTransferOperation: e.value,
                  },
                });
              }}
              options={[
                { label: "YES_NO.YES", key: "true" },
                { label: "YES_NO.NO", key: "false" },
              ]}
              value={this.state?.part?.isPartOpenToTransferOperation?.toString()}
              isRequired={false}
              isDisabled={false}
              visible={true}
            />
          </CardContent>
          <Button
            variant="contained"
            className={classes.savePart}
            onClick={(e) => this.handleSave(e)}
          >
            {t("SAVE")}
          </Button>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getPart,
  updateFundPart,
  getEnums,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PartForm)));
